<template>
  <section class="app-itms-main">
    <!-- <div class="main-contant-inner">
      <keep-alive :max="maxPageNumber" :include="keepAliveComponents">
        <router-view v-if="isRouterAlive" :key="key" />
      </keep-alive>
    </div> -->
    <el-scrollbar wrap-class="app-scrollbar-wrapper" class="app-main-scrollbar" style="height:calc(100vh - 144px);">
      <keep-alive :max="maxPageNumber" :include="keepAliveComponents">
        <router-view v-if="isRouterAlive" :key="key" />
      </keep-alive>
    </el-scrollbar>
  </section>
</template>

<script>
import { SappModule } from '@/store/modules/app'

export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    },
    maxPageNumber() {
      return SappModule.maxPageNumber
    },
    isRouterAlive() {
      return SappModule.isRouterAlive
    },
    keepAliveComponents() {
      return SappModule.keepAliveComponents.concat(['AdmissionFenceMapDisplay', 'DriverMap', 'EndToEndTracking', 'vehicleTrajectory'])
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
/* fix css style bug in open el-dialog */
/deep/ .app-main-scrollbar{
  background:#f5f5f5;
  .app-scrollbar-wrapper{
    padding-right: 16px;
    overflow-x: hidden;
    .el-scrollbar__view{
      min-height:100%;
    }
  }
}
.main-contant-inner{
  background:#f5f5f5;
  padding-right: 20px;
  overflow-x: hidden;
}
</style>
